import { createContext, useContext } from 'react'

import type { AccessSnapshot, ImportStatus, RepoParentRef, SyncStatus } from '@/lib/types'

export interface RepoMeta {
  id: number
  defaultBranch: string
  description: string | null
  isPrivate: boolean
  name: string
  owner: string
  ownerType: 'user' | 'organization'
  isBackup: boolean
  externalUrl: string | null
  parent: RepoParentRef | null
  externalSourceUrl: string | null
  forkCount: number
  importStatus: ImportStatus
  syncStatus: SyncStatus
  lastSyncedAt: string | number | Date | null
  lastSyncError: string | null
  canAdmin: boolean
  permissions: AccessSnapshot
  issuesEnabled: boolean
  openIssues: number
  openPulls: number
  canPin: boolean
  isPinned: boolean
  starCount: number
  isStarred: boolean
  refresh: () => void
}

export const RepoContext = createContext<RepoMeta | null>(null)

export function useRepoMeta() {
  return useContext(RepoContext)
}
